import { useParams } from 'react-router-dom';
import FacilitatorContractExtras from '../../../../calls/facilitator/FacilitatorContractExtras';
import ContractProfileLayoutWrapper from '../../ContractProfileLayoutWrapper';

const ContractFacilitatorExtras = () => {
    const { id = '' } = useParams<{ id: string }>();

    return (
        <ContractProfileLayoutWrapper>
            <FacilitatorContractExtras contractId={id} />
        </ContractProfileLayoutWrapper>
    );
};

export default ContractFacilitatorExtras;
